module.exports = __webpack_public_path__ + "img/hand-back-fist.a3df379a.svg";